import { combineReducers } from 'redux';

import consultaPesquisaNomeSocialFiliacao from './consultaPesquisaNomeSocialFiliacao/reducer';

export default combineReducers({
	consultaPesquisaNomeSocialFiliacao,
});
